module.exports = __webpack_public_path__ + "img/Studio D.d92d8caf.jpg";